import { initializeSecurityControlViewer } from './SecurityControlViewer/SecurityControlViewer.initialize';

export default function initializeSecurityControl() {
    initializeSecurityControlViewer();
}
